export class ParcelInfo {
  providerId: string;
  reference: string;
  extraInfo?: any;
}
